module.exports = __webpack_public_path__ + "static/media/ambrussum_via_tn.b2ff4851.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/ambrussum_via_tn.jpg
// module id = 702
// module chunks = 0